//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
let d=[[[0,"AdministrationBypass",1,0],[0,"AdministrationLogging",1,0],[0,"ApplicationLogging",1,0],[0,"Group",1,0],[0,"IsAdministrator",0,0],[0,"Journaling",1,0],[0,"LocalVolume",1,0],[0,"LocationCode",1,0],[0,"Project",1,0],[0,"Role",1,0],[0,"SecurityLogging",1,0],[0,"Volume",1,0]],[[["ngroups"],"GetGroups",{R_:{groups:""}},0,0],[["nroles"],"GetRoles",{R_:{roles:""}},0,0],[["nvolumes"],"GetVolumes",{R_:{volumes:""}},0,0],[["nlocalVolumes"],"GetLocalVolumes",{R_:{localVolumes:""}},0,0],[["nlocationCodes"],"GetLocationCodes",{R_:{locationCodes:""}},0,0],[["nprojects"],"GetProjects",{R_:{projects:""}},0,0],[[],"Apply",{},0,0],[[],"Dispose",{},0,0],[["log_file_name"],"DumpValidationInfo",{},1,0],[[],"ApplyAndRefresh",{},0,0]],[]];
SPLM.PDM.SessionSettings = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.SessionSettings";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;